$(document)
  .on('click', '#to_form', function() {
    if($('#sidebar').offset()){
      $('html, body').animate({
        scrollTop: $('#sidebar').offset().top
      }, 800)
      $('#info_request_first_name').focus()
    }
    else{
      const id = document.getElementById('info_request_first_name')
      const element = document.getElementsByClassName('scroll-transition scrolled')[0]
      let yOffset = 0
      if(element) { yOffset = -element.offsetHeight }
      const y = id.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({top: y, behavior: 'smooth'})

      setTimeout( function() { $('#info_request_first_name').focus()}, 800 )
    }
  })

  .on('turbo:load', () => {
    if ($('.package-paths').data('hide-pricing')) {
      $('.package-paths .pricing').css('display', 'none')
    }
  })

$(document)
if (window.name === 'ausopen') {
  $('.ticket-table-head').on('click', function() {
    const caret = $(this).find('.custom-caret')
    if (caret.length) {
      caret.toggleClass('rotate')
    }
  })
}
  
